import { Routes } from '@angular/router';
import { Country } from './country/country';
import { DataOrigin } from './data-origin/data-origin';
import { Department } from './department/department';
import { ForestryStatus } from './forestry-status/forestry-status';
import { AreaType } from './area-type/area-type';
import { LandCover } from './land-cover/land-cover';
import { ConservationType } from './conservation-type/conservation-type';
import { IncidentDetection } from './incident-detection/incident-detection';
import { FirebreakType } from './firebreak-type/firebreak-type';
import { Intensity } from './intensity/intensity';
import { IncidentOrigin } from './incident-origin/incident-origin';
import { IncidentCause } from './incident-cause/incident-cause';
import { IncidentType } from './incident-type/incident-type';
import { Region } from './region/region';
import { InterventionType } from './intervention-type/intervention-type';
import { PlantationType } from './plantation-type/plantation-type';
import { PileStatus } from './pile-status/pile-status';
import { PileType } from './pile-type/pile-type';
import { RegistryType } from './registry-type/registry-type';
import { SoilUseGroup } from './soil-use-group/soil-use-group';
import { SoilUse } from './soil-use/soil-use';
import { NurseryType } from './nursery-type/nursery-type';
import { SoilGroup } from './soil-group/soil-group';
import { SoilSpecie } from './soil-specie/soil-specie';
import { SpacingType } from './spacing-type/spacing-type';
import { SoilStratumType } from './soil-stratum-type/soil-stratum-type';
import { SoilAptitude } from './soil-aptitude/soil-aptitude';
import { SpecificConsumptionType } from './specific-consumption-type/specific-consumption-type';
import { SoilMeasurementType } from './soil-measurement-type/soil-measurement-type';
import { SurveyType } from './survey-type/survey-type';
import { StandAreaMaintenanceType } from './stand-area-maintenance-type/stand-area-maintenance-type';
import { SuperiorClasification } from './superior-clasification/superior-clasification';
import { SubEnvironment } from './sub-environment/sub-environment';
import { ThirdPartyPropertyCategory } from './third-party-property-category/third-party-property-category';
import { StrategicCommercialZone } from './strategic-commercial-zone/strategic-commercial-zone';
import { SanitaryClassification } from './sanitary-classification/sanitary-classification';
import { FaunaClass } from './fauna-class/fauna-class';
import { MainDiagnosis } from './main-diagnosis/main-diagnosis';
import { SwcType } from './swc-type/swc-type';
import { SpecieFamily } from './specie-family/specie-family';
import { IntensityDegree } from './intensity-degree/intensity-degree';
import { FloraSpecie } from './flora-specie/flora-specie';
import { RotationPurpose } from './rotation-purpose/rotation-purpose';
import { SeedlingOrigin } from './seedling-origin/seedling-origin';
import { RotationUse } from './rotation-use/rotation-use';
import { Genus } from './genus/genus';
import { ForestrySituation } from './forestry-situation/forestry-situation';
import { LogyardType } from './logyard-type/logyard-type';
import { Logyard } from './logyard/logyard';
import { LocationType } from './location-type/location-type';
import { Location } from './location/location';
import { WoodChainCustody } from './wood-chain-custody/wood-chain-custody';
import { Deposit } from './deposit/deposit';
import { Subregion } from './subregion/subregion';
import { LocalityType } from './locality-type/locality-type';
import { ThirdPartyProperty } from './third-party-property/third-party-property';
import { Firebreak } from './firebreak/firebreak';
import { Zone } from './zone/zone';
import { Property } from './property/property';
import { Nursery } from './nursery/nursery';
import { Locality } from './locality/locality';
import { Stand } from './stand/stand';
import { Register } from './register/register';
import { OtherUse } from './other-use/other-use';
import { CadastralSection } from './cadastral-section/cadastral-section';
import { Office } from './office/office';
import { InternalRoad } from './internal-road/internal-road';
import { FirebreakBlock } from './firebreak-block/firebreak-block';
import { LocalCorridor } from './local-corridor/local-corridor';
import { RegisterPerProperty } from './register-per-property/register-per-property';
import { LoadProperty } from './load-property/load-property';
import { EleIs } from './ele-is/ele-is';
import { Fence } from './fence/fence';
import { Helmet } from './helmet/helmet';
import { LocalRoad } from './local-road/local-road';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { COUNTRY_CONFIG } from './country/country.config';
import { DATAORIGIN_CONFIG } from './data-origin/data-origin.config';
import { DEPARTMENT_CONFIG } from './department/department.config';
import { FORESTRYSTATUS_CONFIG } from './forestry-status/forestry-status.config';
import { AREATYPE_CONFIG } from './area-type/area-type.config';
import { LANDCOVER_CONFIG } from './land-cover/land-cover.config';
import { CONSERVATIONTYPE_CONFIG } from './conservation-type/conservation-type.config';
import { INCIDENTDETECTION_CONFIG } from './incident-detection/incident-detection.config';
import { FIREBREAKTYPE_CONFIG } from './firebreak-type/firebreak-type.config';
import { INTENSITY_CONFIG } from './intensity/intensity.config';
import { INCIDENTORIGIN_CONFIG } from './incident-origin/incident-origin.config';
import { INCIDENTCAUSE_CONFIG } from './incident-cause/incident-cause.config';
import { INCIDENTTYPE_CONFIG } from './incident-type/incident-type.config';
import { REGION_CONFIG } from './region/region.config';
import { INTERVENTIONTYPE_CONFIG } from './intervention-type/intervention-type.config';
import { PLANTATIONTYPE_CONFIG } from './plantation-type/plantation-type.config';
import { PILESTATUS_CONFIG } from './pile-status/pile-status.config';
import { PILETYPE_CONFIG } from './pile-type/pile-type.config';
import { REGISTRYTYPE_CONFIG } from './registry-type/registry-type.config';
import { SOILUSEGROUP_CONFIG } from './soil-use-group/soil-use-group.config';
import { SOILUSE_CONFIG } from './soil-use/soil-use.config';
import { NURSERYTYPE_CONFIG } from './nursery-type/nursery-type.config';
import { SOILGROUP_CONFIG } from './soil-group/soil-group.config';
import { SOILSPECIE_CONFIG } from './soil-specie/soil-specie.config';
import { SPACINGTYPE_CONFIG } from './spacing-type/spacing-type.config';
import { SWCTYPE_CONFIG } from './swc-type/swc-type.config';
import { SOILSTRATUMTYPE_CONFIG } from './soil-stratum-type/soil-stratum-type.config';
import { SOILAPTITUDE_CONFIG } from './soil-aptitude/soil-aptitude.config';
import { SPECIFICCONSUMPTIONTYPE_CONFIG } from './specific-consumption-type/specific-consumption-type.config';
import { SOILMEASUREMENTTYPE_CONFIG } from './soil-measurement-type/soil-measurement-type.config';
import { SURVEYTYPE_CONFIG } from './survey-type/survey-type.config';
import { STANDAREAMAINTENANCETYPE_CONFIG } from './stand-area-maintenance-type/stand-area-maintenance-type.config';
import { SUPERIORCLASIFICATION_CONFIG } from './superior-clasification/superior-clasification.config';
import { SUBENVIRONMENT_CONFIG } from './sub-environment/sub-environment.config';
import { THIRDPARTYPROPERTYCATEGORY_CONFIG } from './third-party-property-category/third-party-property-category.config';
import { STRATEGICCOMMERCIALZONE_CONFIG } from './strategic-commercial-zone/strategic-commercial-zone.config';
import { SANITARYCLASSIFICATION_CONFIG } from './sanitary-classification/sanitary-classification.config';
import { FAUNACLASS_CONFIG } from './fauna-class/fauna-class.config';
import { MAINDIAGNOSIS_CONFIG } from './main-diagnosis/main-diagnosis.config';
import { SPECIEFAMILY_CONFIG } from './specie-family/specie-family.config';
import { INTENSITYDEGREE_CONFIG } from './intensity-degree/intensity-degree.config';
import { FLORASPECIE_CONFIG } from './flora-specie/flora-specie.config';
import { ROTATIONPURPOSE_CONFIG } from './rotation-purpose/rotation-purpose.config';
import { SEEDLINGORIGIN_CONFIG } from './seedling-origin/seedling-origin.config';
import { ROTATIONUSE_CONFIG } from './rotation-use/rotation-use.config';
import { GENUS_CONFIG } from './genus/genus.config';
import { FORESTRYSITUATION_CONFIG } from './forestry-situation/forestry-situation.config';
import { MILL_CONFIG } from './mill/mill.config';
import { OTHERUSEPERREGISTER_CONFIG } from './other-use-per-register/other-use-per-register.config';
import { STANDPERREGISTER_CONFIG } from './stand-per-register/stand-per-register.config';
import { PILE_CONFIG } from './pile/pile.config';
import { MILLSECTORTYPE_CONFIG } from './mill-sector-type/mill-sector-type.config';
import { Mill } from './mill/mill';
import { OtherUsePerRegister } from './other-use-per-register/other-use-per-register';
import { StandPerRegister } from './stand-per-register/stand-per-register';
import { Pile } from './pile/pile';
import { MillSectorType } from './mill-sector-type/mill-sector-type';

import { LOGYARDTYPE_CONFIG } from './logyard-type/logyard-type.config';
import { LOGYARD_CONFIG } from './logyard/logyard.config';
import { LOCATIONTYPE_CONFIG } from './location-type/location-type.config';
import { LOCATION_CONFIG } from './location/location.config';
import { WOODCHAINCUSTODY_CONFIG } from './wood-chain-custody/wood-chain-custody.config';
import { DEPOSIT_CONFIG } from './deposit/deposit.config';
import { SUBREGION_CONFIG } from './subregion/subregion.config';
import { LOCALITYTYPE_CONFIG } from './locality-type/locality-type.config';
import { THIRDPARTYPROPERTY_CONFIG } from './third-party-property/third-party-property.config';
import { FIREBREAK_CONFIG } from './firebreak/firebreak.config';
import { ZONE_CONFIG } from './zone/zone.config';
import { PROPERTY_CONFIG } from './property/property.config';
import { NURSERY_CONFIG } from './nursery/nursery.config';
import { LOCALITY_CONFIG } from './locality/locality.config';
import { STAND_CONFIG } from './stand/stand.config';
import { REGISTER_CONFIG } from './register/register.config';
import { OTHERUSE_CONFIG } from './other-use/other-use.config';
import { CADASTRALSECTION_CONFIG } from './cadastral-section/cadastral-section.config';
import { OFFICE_CONFIG } from './office/office.config';
import { INTERNALROAD_CONFIG } from './internal-road/internal-road.config';
import { FIREBREAKBLOCK_CONFIG } from './firebreak-block/firebreak-block.config';
import { LOCALCORRIDOR_CONFIG } from './local-corridor/local-corridor.config';
import { REGISTERPERPROPERTY_CONFIG } from './register-per-property/register-per-property.config';
import { LOADPROPERTY_CONFIG } from './load-property/load-property.config';
import { ELEIS_CONFIG } from './ele-is/ele-is.config';
import { FENCE_CONFIG } from './fence/fence.config';
import { HELMET_CONFIG } from './helmet/helmet.config';
import { LOCALROAD_CONFIG } from './local-road/local-road.config';
import { MILLSECTOR_CONFIG } from './mill-sector/mill-sector.config';
import { INVENTORYTYPE_CONFIG } from './inventory-type/inventory-type.config';
import { SOILUNIT_CONFIG } from './soil-unit/soil-unit.config';
import { GENDER_CONFIG } from './gender/gender.config';
import { FAUNASPECIE_CONFIG } from './fauna-specie/fauna-specie.config';
import { PACKINGTYPE_CONFIG } from './packing-type/packing-type.config';
import { INVENTORYPARAMETERS_CONFIG } from './inventory-parameters/inventory-parameters.config';
import { SPACING_CONFIG } from './spacing/spacing.config';
import { INVENTORYSUBTYPE_CONFIG } from './inventory-sub-type/inventory-sub-type.config';
import { STANDPERINTERMEDIATELOGYARD_CONFIG } from './stand-per-intermediate-logyard/stand-per-intermediate-logyard.config';
import { PROPERTYTYPEGROUP_CONFIG } from './property-type-group/property-type-group.config';
import { PROPERTYTYPE_CONFIG } from './property-type/property-type.config';
import { MillSector } from './mill-sector/mill-sector';
import { InventoryType } from './inventory-type/inventory-type';
import { SoilUnit } from './soil-unit/soil-unit';
import { Gender } from './gender/gender';
import { FaunaSpecie } from './fauna-specie/fauna-specie';
import { PackingType } from './packing-type/packing-type';
import { InventoryParameters } from './inventory-parameters/inventory-parameters';
import { Spacing } from './spacing/spacing';
import { InventorySubType } from './inventory-sub-type/inventory-sub-type';
import { StandPerIntermediateLogyard } from './stand-per-intermediate-logyard/stand-per-intermediate-logyard';
import { PropertyTypeGroup } from './property-type-group/property-type-group';
import { PropertyType } from './property-type/property-type';
import { ForestryManagement } from './forestry-management/forestry-management';
import { FORESTRYMANAGEMENT_CONFIG } from './forestry-management/forestry-management.config';
import { TreeObservation } from './tree-observation/tree-observation';
import { TREEOBSERVATION_CONFIG } from './tree-observation/tree-observation.config';
import { CROPCODE_CONFIG } from './crop-code/crop-code.config';
import { STANDTYPE_CONFIG } from './stand-type/stand-type.config';
import { INCIDENTCATEGORY_CONFIG } from './incident-category/incident-category.config';
import { CERTIFICATIONCODE_CONFIG } from './certification-code/certification-code.config';
import { TEAM_CONFIG } from './team/team.config';
import { CropCode } from './crop-code/crop-code';
import { StandType } from './stand-type/stand-type';
import { IncidentCategory } from './incident-category/incident-category';
import { CertificationCode } from './certification-code/certification-code';
import { Team } from './team/team';
import { ThirdPartyDestination } from './third-party-destination/third-party-destination';
import { THIRDPARTYDESTINATION_CONFIG } from './third-party-destination/third-party-destination.config';
import { CostCenterByLocation } from './cost-center-by-location/cost-center-by-location';
import { COSTCENTERBYLOCATION_CONFIG } from './cost-center-by-location/cost-center-by-location.config';
import { PileDetail } from './pile-detail/pile-detail';
import { PILEDETAIL_CONFIG } from './pile-detail/pile-detail.config';
import { SupplyRegister } from './supply-register/supply-register';
import { SUPPLYREGISTER_CONFIG } from './supply-register/supply-register.config';
import { SupplyRegisterPerThirdPartyProperty } from './supply-register-per-third-party-property/supply-register-per-third-party-property';
import { SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG } from './supply-register-per-third-party-property/supply-register-per-third-party-property.config';
import { REGISTERAREA_CONFIG } from './register-area/register-area.config';
import { REGISTERVALUE_CONFIG } from './register-value/register-value.config';
import { CERTIFICATETYPE_CONFIG } from './certificate-type/certificate-type.config';
import { CERTIFICATIONLEVEL_CONFIG } from './certification-level/certification-level.config';
import { CERTIFICATIONTYPE_CONFIG } from './certification-type/certification-type.config';
import { CERTIFICATOR_CONFIG } from './certificator/certificator.config';
import { DISTRIBUTION_CONFIG } from './distribution/distribution.config';
import { FLOWTYPE_CONFIG } from './flow-type/flow-type.config';
import { MANAGEMENTTYPE_CONFIG } from './management-type/management-type.config';
import { REGISTERTYPE_CONFIG } from './register-type/register-type.config';
import { SOILBASEDCROPCODE_CONFIG } from './soil-based-crop-code/soil-based-crop-code.config';
import { WOODSTATEMENT_CONFIG } from './wood-statement/wood-statement.config';
import { RegisterArea } from './register-area/register-area';
import { RegisterValue } from './register-value/register-value';
import { CertificateType } from './certificate-type/certificate-type';
import { CertificationLevel } from './certification-level/certification-level';
import { CertificationType } from './certification-type/certification-type';
import { Certificator } from './certificator/certificator';
import { Distribution } from './distribution/distribution';
import { FlowType } from './flow-type/flow-type';
import { ManagementType } from './management-type/management-type';
import { RegisterType } from './register-type/register-type';
import { SoilBasedCropCode } from './soil-based-crop-code/soil-based-crop-code';
import { WoodStatement } from './wood-statement/wood-statement';
export const routes: Routes = [];
export const PLANNING_ROUTES: Routes = [
  {
      path: 'forestry-management',
      pathMatch: 'full',
      component: ForestryManagement,
      canActivate: [authGuard, permissionGuard],
      data: {
        requiredPolicy: FORESTRYMANAGEMENT_CONFIG.permission,
        showInMenu: FORESTRYMANAGEMENT_CONFIG.showInMenu,
        menuCategory: FORESTRYMANAGEMENT_CONFIG.menuCategory,
        menuSubcategory: FORESTRYMANAGEMENT_CONFIG.menuSubcategory,
        menuTitle: FORESTRYMANAGEMENT_CONFIG.localizationKey,
      },
    },
  {
    path: 'country',
    pathMatch: 'full',
    component: Country,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COUNTRY_CONFIG.permission,
      showInMenu: COUNTRY_CONFIG.showInMenu,
      menuCategory: COUNTRY_CONFIG.menuCategory,
      menuSubcategory: COUNTRY_CONFIG.menuSubcategory,
      menuTitle: COUNTRY_CONFIG.localizationKey,
    },
  },
  {
    path: 'data-origin',
    pathMatch: 'full',
    component: DataOrigin,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DATAORIGIN_CONFIG.permission,
      showInMenu: DATAORIGIN_CONFIG.showInMenu,
      menuCategory: DATAORIGIN_CONFIG.menuCategory,
      menuSubcategory: DATAORIGIN_CONFIG.menuSubcategory,
      menuTitle: DATAORIGIN_CONFIG.localizationKey,
    },
  },
  {
    path: 'department',
    pathMatch: 'full',
    component: Department,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DEPARTMENT_CONFIG.permission,
      showInMenu: DEPARTMENT_CONFIG.showInMenu,
      menuCategory: DEPARTMENT_CONFIG.menuCategory,
      menuSubcategory: DEPARTMENT_CONFIG.menuSubcategory,
      menuTitle: DEPARTMENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'forestry-status',
    pathMatch: 'full',
    component: ForestryStatus,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORESTRYSTATUS_CONFIG.permission,
      showInMenu: FORESTRYSTATUS_CONFIG.showInMenu,
      menuCategory: FORESTRYSTATUS_CONFIG.menuCategory,
      menuSubcategory: FORESTRYSTATUS_CONFIG.menuSubcategory,
      menuTitle: FORESTRYSTATUS_CONFIG.localizationKey,
    },
  },
  {
    path: 'area-type',
    pathMatch: 'full',
    component: AreaType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: AREATYPE_CONFIG.permission,
      showInMenu: AREATYPE_CONFIG.showInMenu,
      menuCategory: AREATYPE_CONFIG.menuCategory,
      menuSubcategory: AREATYPE_CONFIG.menuSubcategory,
      menuTitle: AREATYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'land-cover',
    pathMatch: 'full',
    component: LandCover,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LANDCOVER_CONFIG.permission,
      showInMenu: LANDCOVER_CONFIG.showInMenu,
      menuCategory: LANDCOVER_CONFIG.menuCategory,
      menuSubcategory: LANDCOVER_CONFIG.menuSubcategory,
      menuTitle: LANDCOVER_CONFIG.localizationKey,
    },
  },
  {
    path: 'conservation-type',
    pathMatch: 'full',
    component: ConservationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONSERVATIONTYPE_CONFIG.permission,
      showInMenu: CONSERVATIONTYPE_CONFIG.showInMenu,
      menuCategory: CONSERVATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: CONSERVATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: CONSERVATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-detection',
    pathMatch: 'full',
    component: IncidentDetection,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTDETECTION_CONFIG.permission,
      showInMenu: INCIDENTDETECTION_CONFIG.showInMenu,
      menuCategory: INCIDENTDETECTION_CONFIG.menuCategory,
      menuSubcategory: INCIDENTDETECTION_CONFIG.menuSubcategory,
      menuTitle: INCIDENTDETECTION_CONFIG.localizationKey,
    },
  },
  {
    path: 'firebreak-type',
    pathMatch: 'full',
    component: FirebreakType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FIREBREAKTYPE_CONFIG.permission,
      showInMenu: FIREBREAKTYPE_CONFIG.showInMenu,
      menuCategory: FIREBREAKTYPE_CONFIG.menuCategory,
      menuSubcategory: FIREBREAKTYPE_CONFIG.menuSubcategory,
      menuTitle: FIREBREAKTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'intensity',
    pathMatch: 'full',
    component: Intensity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTENSITY_CONFIG.permission,
      showInMenu: INTENSITY_CONFIG.showInMenu,
      menuCategory: INTENSITY_CONFIG.menuCategory,
      menuSubcategory: INTENSITY_CONFIG.menuSubcategory,
      menuTitle: INTENSITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-origin',
    pathMatch: 'full',
    component: IncidentOrigin,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTORIGIN_CONFIG.permission,
      showInMenu: INCIDENTORIGIN_CONFIG.showInMenu,
      menuCategory: INCIDENTORIGIN_CONFIG.menuCategory,
      menuSubcategory: INCIDENTORIGIN_CONFIG.menuSubcategory,
      menuTitle: INCIDENTORIGIN_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-cause',
    pathMatch: 'full',
    component: IncidentCause,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTCAUSE_CONFIG.permission,
      showInMenu: INCIDENTCAUSE_CONFIG.showInMenu,
      menuCategory: INCIDENTCAUSE_CONFIG.menuCategory,
      menuSubcategory: INCIDENTCAUSE_CONFIG.menuSubcategory,
      menuTitle: INCIDENTCAUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-type',
    pathMatch: 'full',
    component: IncidentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTTYPE_CONFIG.permission,
      showInMenu: INCIDENTTYPE_CONFIG.showInMenu,
      menuCategory: INCIDENTTYPE_CONFIG.menuCategory,
      menuSubcategory: INCIDENTTYPE_CONFIG.menuSubcategory,
      menuTitle: INCIDENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'region',
    pathMatch: 'full',
    component: Region,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGION_CONFIG.permission,
      showInMenu: REGION_CONFIG.showInMenu,
      menuCategory: REGION_CONFIG.menuCategory,
      menuSubcategory: REGION_CONFIG.menuSubcategory,
      menuTitle: REGION_CONFIG.localizationKey,
    },
  },
  {
    path: 'intervention-type',
    pathMatch: 'full',
    component: InterventionType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERVENTIONTYPE_CONFIG.permission,
      showInMenu: INTERVENTIONTYPE_CONFIG.showInMenu,
      menuCategory: INTERVENTIONTYPE_CONFIG.menuCategory,
      menuSubcategory: INTERVENTIONTYPE_CONFIG.menuSubcategory,
      menuTitle: INTERVENTIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'plantation-type',
    pathMatch: 'full',
    component: PlantationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANTATIONTYPE_CONFIG.permission,
      showInMenu: PLANTATIONTYPE_CONFIG.showInMenu,
      menuCategory: PLANTATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: PLANTATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: PLANTATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'pile-status',
    pathMatch: 'full',
    component: PileStatus,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PILESTATUS_CONFIG.permission,
      showInMenu: PILESTATUS_CONFIG.showInMenu,
      menuCategory: PILESTATUS_CONFIG.menuCategory,
      menuSubcategory: PILESTATUS_CONFIG.menuSubcategory,
      menuTitle: PILESTATUS_CONFIG.localizationKey,
    },
  },
  {
    path: 'pile-type',
    pathMatch: 'full',
    component: PileType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PILETYPE_CONFIG.permission,
      showInMenu: PILETYPE_CONFIG.showInMenu,
      menuCategory: PILETYPE_CONFIG.menuCategory,
      menuSubcategory: PILETYPE_CONFIG.menuSubcategory,
      menuTitle: PILETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'registry-type',
    pathMatch: 'full',
    component: RegistryType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTRYTYPE_CONFIG.permission,
      showInMenu: REGISTRYTYPE_CONFIG.showInMenu,
      menuCategory: REGISTRYTYPE_CONFIG.menuCategory,
      menuSubcategory: REGISTRYTYPE_CONFIG.menuSubcategory,
      menuTitle: REGISTRYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-use-group',
    pathMatch: 'full',
    component: SoilUseGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILUSEGROUP_CONFIG.permission,
      showInMenu: SOILUSEGROUP_CONFIG.showInMenu,
      menuCategory: SOILUSEGROUP_CONFIG.menuCategory,
      menuSubcategory: SOILUSEGROUP_CONFIG.menuSubcategory,
      menuTitle: SOILUSEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-use',
    pathMatch: 'full',
    component: SoilUse,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILUSE_CONFIG.permission,
      showInMenu: SOILUSE_CONFIG.showInMenu,
      menuCategory: SOILUSE_CONFIG.menuCategory,
      menuSubcategory: SOILUSE_CONFIG.menuSubcategory,
      menuTitle: SOILUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'nursery-type',
    pathMatch: 'full',
    component: NurseryType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NURSERYTYPE_CONFIG.permission,
      showInMenu: NURSERYTYPE_CONFIG.showInMenu,
      menuCategory: NURSERYTYPE_CONFIG.menuCategory,
      menuSubcategory: NURSERYTYPE_CONFIG.menuSubcategory,
      menuTitle: NURSERYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-group',
    pathMatch: 'full',
    component: SoilGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILGROUP_CONFIG.permission,
      showInMenu: SOILGROUP_CONFIG.showInMenu,
      menuCategory: SOILGROUP_CONFIG.menuCategory,
      menuSubcategory: SOILGROUP_CONFIG.menuSubcategory,
      menuTitle: SOILGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-specie',
    pathMatch: 'full',
    component: SoilSpecie,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILSPECIE_CONFIG.permission,
      showInMenu: SOILSPECIE_CONFIG.showInMenu,
      menuCategory: SOILSPECIE_CONFIG.menuCategory,
      menuSubcategory: SOILSPECIE_CONFIG.menuSubcategory,
      menuTitle: SOILSPECIE_CONFIG.localizationKey,
    },
  },
  {
    path: 'spacing-type',
    pathMatch: 'full',
    component: SpacingType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPACINGTYPE_CONFIG.permission,
      showInMenu: SPACINGTYPE_CONFIG.showInMenu,
      menuCategory: SPACINGTYPE_CONFIG.menuCategory,
      menuSubcategory: SPACINGTYPE_CONFIG.menuSubcategory,
      menuTitle: SPACINGTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'swc-type',
    pathMatch: 'full',
    component: SwcType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SWCTYPE_CONFIG.permission,
      showInMenu: SWCTYPE_CONFIG.showInMenu,
      menuCategory: SWCTYPE_CONFIG.menuCategory,
      menuSubcategory: SWCTYPE_CONFIG.menuSubcategory,
      menuTitle: SWCTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-stratum-type',
    pathMatch: 'full',
    component: SoilStratumType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILSTRATUMTYPE_CONFIG.permission,
      showInMenu: SOILSTRATUMTYPE_CONFIG.showInMenu,
      menuCategory: SOILSTRATUMTYPE_CONFIG.menuCategory,
      menuSubcategory: SOILSTRATUMTYPE_CONFIG.menuSubcategory,
      menuTitle: SOILSTRATUMTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-aptitude',
    pathMatch: 'full',
    component: SoilAptitude,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILAPTITUDE_CONFIG.permission,
      showInMenu: SOILAPTITUDE_CONFIG.showInMenu,
      menuCategory: SOILAPTITUDE_CONFIG.menuCategory,
      menuSubcategory: SOILAPTITUDE_CONFIG.menuSubcategory,
      menuTitle: SOILAPTITUDE_CONFIG.localizationKey,
    },
  },
  {
    path: 'specific-consumption-type',
    pathMatch: 'full',
    component: SpecificConsumptionType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIFICCONSUMPTIONTYPE_CONFIG.permission,
      showInMenu: SPECIFICCONSUMPTIONTYPE_CONFIG.showInMenu,
      menuCategory: SPECIFICCONSUMPTIONTYPE_CONFIG.menuCategory,
      menuSubcategory: SPECIFICCONSUMPTIONTYPE_CONFIG.menuSubcategory,
      menuTitle: SPECIFICCONSUMPTIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-measurement-type',
    pathMatch: 'full',
    component: SoilMeasurementType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILMEASUREMENTTYPE_CONFIG.permission,
      showInMenu: SOILMEASUREMENTTYPE_CONFIG.showInMenu,
      menuCategory: SOILMEASUREMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: SOILMEASUREMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: SOILMEASUREMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'survey-type',
    pathMatch: 'full',
    component: SurveyType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SURVEYTYPE_CONFIG.permission,
      showInMenu: SURVEYTYPE_CONFIG.showInMenu,
      menuCategory: SURVEYTYPE_CONFIG.menuCategory,
      menuSubcategory: SURVEYTYPE_CONFIG.menuSubcategory,
      menuTitle: SURVEYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-area-maintenance-type',
    pathMatch: 'full',
    component: StandAreaMaintenanceType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDAREAMAINTENANCETYPE_CONFIG.permission,
      showInMenu: STANDAREAMAINTENANCETYPE_CONFIG.showInMenu,
      menuCategory: STANDAREAMAINTENANCETYPE_CONFIG.menuCategory,
      menuSubcategory: STANDAREAMAINTENANCETYPE_CONFIG.menuSubcategory,
      menuTitle: STANDAREAMAINTENANCETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'superior-clasification',
    pathMatch: 'full',
    component: SuperiorClasification,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUPERIORCLASIFICATION_CONFIG.permission,
      showInMenu: SUPERIORCLASIFICATION_CONFIG.showInMenu,
      menuCategory: SUPERIORCLASIFICATION_CONFIG.menuCategory,
      menuSubcategory: SUPERIORCLASIFICATION_CONFIG.menuSubcategory,
      menuTitle: SUPERIORCLASIFICATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'sub-environment',
    pathMatch: 'full',
    component: SubEnvironment,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUBENVIRONMENT_CONFIG.permission,
      showInMenu: SUBENVIRONMENT_CONFIG.showInMenu,
      menuCategory: SUBENVIRONMENT_CONFIG.menuCategory,
      menuSubcategory: SUBENVIRONMENT_CONFIG.menuSubcategory,
      menuTitle: SUBENVIRONMENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'third-property-category',
    pathMatch: 'full',
    component: ThirdPartyPropertyCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: THIRDPARTYPROPERTYCATEGORY_CONFIG.permission,
      showInMenu: THIRDPARTYPROPERTYCATEGORY_CONFIG.showInMenu,
      menuCategory: THIRDPARTYPROPERTYCATEGORY_CONFIG.menuCategory,
      menuSubcategory: THIRDPARTYPROPERTYCATEGORY_CONFIG.menuSubcategory,
      menuTitle: THIRDPARTYPROPERTYCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'strategic-commercial-zone',
    pathMatch: 'full',
    component: StrategicCommercialZone,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STRATEGICCOMMERCIALZONE_CONFIG.permission,
      showInMenu: STRATEGICCOMMERCIALZONE_CONFIG.showInMenu,
      menuCategory: STRATEGICCOMMERCIALZONE_CONFIG.menuCategory,
      menuSubcategory: STRATEGICCOMMERCIALZONE_CONFIG.menuSubcategory,
      menuTitle: STRATEGICCOMMERCIALZONE_CONFIG.localizationKey,
    },
  },
  {
    path: 'sanitary-classification',
    pathMatch: 'full',
    component: SanitaryClassification,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SANITARYCLASSIFICATION_CONFIG.permission,
      showInMenu: SANITARYCLASSIFICATION_CONFIG.showInMenu,
      menuCategory: SANITARYCLASSIFICATION_CONFIG.menuCategory,
      menuSubcategory: SANITARYCLASSIFICATION_CONFIG.menuSubcategory,
      menuTitle: SANITARYCLASSIFICATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'fauna-class',
    pathMatch: 'full',
    component: FaunaClass,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FAUNACLASS_CONFIG.permission,
      showInMenu: FAUNACLASS_CONFIG.showInMenu,
      menuCategory: FAUNACLASS_CONFIG.menuCategory,
      menuSubcategory: FAUNACLASS_CONFIG.menuSubcategory,
      menuTitle: FAUNACLASS_CONFIG.localizationKey,
    },
  },
  {
    path: 'main-diagnosis',
    pathMatch: 'full',
    component: MainDiagnosis,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MAINDIAGNOSIS_CONFIG.permission,
      showInMenu: MAINDIAGNOSIS_CONFIG.showInMenu,
      menuCategory: MAINDIAGNOSIS_CONFIG.menuCategory,
      menuSubcategory: MAINDIAGNOSIS_CONFIG.menuSubcategory,
      menuTitle: MAINDIAGNOSIS_CONFIG.localizationKey,
    },
  },
  {
    path: 'specie-family',
    pathMatch: 'full',
    component: SpecieFamily,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIEFAMILY_CONFIG.permission,
      showInMenu: SPECIEFAMILY_CONFIG.showInMenu,
      menuCategory: SPECIEFAMILY_CONFIG.menuCategory,
      menuSubcategory: SPECIEFAMILY_CONFIG.menuSubcategory,
      menuTitle: SPECIEFAMILY_CONFIG.localizationKey,
    },
  },
  {
    path: 'intensity-degree',
    pathMatch: 'full',
    component: IntensityDegree,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTENSITYDEGREE_CONFIG.permission,
      showInMenu: INTENSITYDEGREE_CONFIG.showInMenu,
      menuCategory: INTENSITYDEGREE_CONFIG.menuCategory,
      menuSubcategory: INTENSITYDEGREE_CONFIG.menuSubcategory,
      menuTitle: INTENSITYDEGREE_CONFIG.localizationKey,
    },
  },
  {
    path: 'flora-specie',
    pathMatch: 'full',
    component: FloraSpecie,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FLORASPECIE_CONFIG.permission,
      showInMenu: FLORASPECIE_CONFIG.showInMenu,
      menuCategory: FLORASPECIE_CONFIG.menuCategory,
      menuSubcategory: FLORASPECIE_CONFIG.menuSubcategory,
      menuTitle: FLORASPECIE_CONFIG.localizationKey,
    },
  },
  {
    path: 'rotation-purpose',
    pathMatch: 'full',
    component: RotationPurpose,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROTATIONPURPOSE_CONFIG.permission,
      showInMenu: ROTATIONPURPOSE_CONFIG.showInMenu,
      menuCategory: ROTATIONPURPOSE_CONFIG.menuCategory,
      menuSubcategory: ROTATIONPURPOSE_CONFIG.menuSubcategory,
      menuTitle: ROTATIONPURPOSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'seedling-origin',
    pathMatch: 'full',
    component: SeedlingOrigin,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SEEDLINGORIGIN_CONFIG.permission,
      showInMenu: SEEDLINGORIGIN_CONFIG.showInMenu,
      menuCategory: SEEDLINGORIGIN_CONFIG.menuCategory,
      menuSubcategory: SEEDLINGORIGIN_CONFIG.menuSubcategory,
      menuTitle: SEEDLINGORIGIN_CONFIG.localizationKey,
    },
  },
  {
    path: 'rotation-use',
    pathMatch: 'full',
    component: RotationUse,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROTATIONUSE_CONFIG.permission,
      showInMenu: ROTATIONUSE_CONFIG.showInMenu,
      menuCategory: ROTATIONUSE_CONFIG.menuCategory,
      menuSubcategory: ROTATIONUSE_CONFIG.menuSubcategory,
      menuTitle: ROTATIONUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'genus',
    pathMatch: 'full',
    component: Genus,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENUS_CONFIG.permission,
      showInMenu: GENUS_CONFIG.showInMenu,
      menuCategory: GENUS_CONFIG.menuCategory,
      menuSubcategory: GENUS_CONFIG.menuSubcategory,
      menuTitle: GENUS_CONFIG.localizationKey,
    },
  },
  {
    path: 'forestry-situation',
    pathMatch: 'full',
    component: ForestrySituation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORESTRYSITUATION_CONFIG.permission,
      showInMenu: FORESTRYSITUATION_CONFIG.showInMenu,
      menuCategory: FORESTRYSITUATION_CONFIG.menuCategory,
      menuSubcategory: FORESTRYSITUATION_CONFIG.menuSubcategory,
      menuTitle: FORESTRYSITUATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'tree-observation',
    pathMatch: 'full',
    component: TreeObservation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TREEOBSERVATION_CONFIG.permission,
      showInMenu: TREEOBSERVATION_CONFIG.showInMenu,
      menuCategory: TREEOBSERVATION_CONFIG.menuCategory,
      menuSubcategory: TREEOBSERVATION_CONFIG.menuSubcategory,
      menuTitle: TREEOBSERVATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'logyard-type',
    pathMatch: 'full',
    component: LogyardType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOGYARDTYPE_CONFIG.permission,
      showInMenu: LOGYARDTYPE_CONFIG.showInMenu,
      menuCategory: LOGYARDTYPE_CONFIG.menuCategory,
      menuSubcategory: LOGYARDTYPE_CONFIG.menuSubcategory,
      menuTitle: LOGYARDTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'logyard',
    pathMatch: 'full',
    component: Logyard,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOGYARD_CONFIG.permission,
      showInMenu: LOGYARD_CONFIG.showInMenu,
      menuCategory: LOGYARD_CONFIG.menuCategory,
      menuSubcategory: LOGYARD_CONFIG.menuSubcategory,
      menuTitle: LOGYARD_CONFIG.localizationKey,
    },
  },
  {
    path: 'location-type',
    pathMatch: 'full',
    component: LocationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCATIONTYPE_CONFIG.permission,
      showInMenu: LOCATIONTYPE_CONFIG.showInMenu,
      menuCategory: LOCATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: LOCATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: LOCATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'location',
    pathMatch: 'full',
    component: Location,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCATION_CONFIG.permission,
      showInMenu: LOCATION_CONFIG.showInMenu,
      menuCategory: LOCATION_CONFIG.menuCategory,
      menuSubcategory: LOCATION_CONFIG.menuSubcategory,
      menuTitle: LOCATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-chain-custody',
    pathMatch: 'full',
    component: WoodChainCustody,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODCHAINCUSTODY_CONFIG.permission,
      showInMenu: WOODCHAINCUSTODY_CONFIG.showInMenu,
      menuCategory: WOODCHAINCUSTODY_CONFIG.menuCategory,
      menuSubcategory: WOODCHAINCUSTODY_CONFIG.menuSubcategory,
      menuTitle: WOODCHAINCUSTODY_CONFIG.localizationKey,
    },
  },
  {
    path: 'deposit',
    pathMatch: 'full',
    component: Deposit,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DEPOSIT_CONFIG.permission,
      showInMenu: DEPOSIT_CONFIG.showInMenu,
      menuCategory: DEPOSIT_CONFIG.menuCategory,
      menuSubcategory: DEPOSIT_CONFIG.menuSubcategory,
      menuTitle: DEPOSIT_CONFIG.localizationKey,
    },
  },
  {
    path: 'subregion',
    pathMatch: 'full',
    component: Subregion,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUBREGION_CONFIG.permission,
      showInMenu: SUBREGION_CONFIG.showInMenu,
      menuCategory: SUBREGION_CONFIG.menuCategory,
      menuSubcategory: SUBREGION_CONFIG.menuSubcategory,
      menuTitle: SUBREGION_CONFIG.localizationKey,
    },
  },
  {
    path: 'locality-type',
    pathMatch: 'full',
    component: LocalityType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCALITYTYPE_CONFIG.permission,
      showInMenu: LOCALITYTYPE_CONFIG.showInMenu,
      menuCategory: LOCALITYTYPE_CONFIG.menuCategory,
      menuSubcategory: LOCALITYTYPE_CONFIG.menuSubcategory,
      menuTitle: LOCALITYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'third-party-property',
    pathMatch: 'full',
    component: ThirdPartyProperty,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: THIRDPARTYPROPERTY_CONFIG.permission,
      showInMenu: THIRDPARTYPROPERTY_CONFIG.showInMenu,
      menuCategory: THIRDPARTYPROPERTY_CONFIG.menuCategory,
      menuSubcategory: THIRDPARTYPROPERTY_CONFIG.menuSubcategory,
      menuTitle: THIRDPARTYPROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'firebreak',
    pathMatch: 'full',
    component: Firebreak,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FIREBREAK_CONFIG.permission,
      showInMenu: FIREBREAK_CONFIG.showInMenu,
      menuCategory: FIREBREAK_CONFIG.menuCategory,
      menuSubcategory: FIREBREAK_CONFIG.menuSubcategory,
      menuTitle: FIREBREAK_CONFIG.localizationKey,
    },
  },
  {
    path: 'zone',
    pathMatch: 'full',
    component: Zone,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ZONE_CONFIG.permission,
      showInMenu: ZONE_CONFIG.showInMenu,
      menuCategory: ZONE_CONFIG.menuCategory,
      menuSubcategory: ZONE_CONFIG.menuSubcategory,
      menuTitle: ZONE_CONFIG.localizationKey,
    },
  },
  {
    path: 'property',
    pathMatch: 'full',
    component: Property,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTY_CONFIG.permission,
      showInMenu: PROPERTY_CONFIG.showInMenu,
      menuCategory: PROPERTY_CONFIG.menuCategory,
      menuSubcategory: PROPERTY_CONFIG.menuSubcategory,
      menuTitle: PROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'nursery',
    pathMatch: 'full',
    component: Nursery,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NURSERY_CONFIG.permission,
      showInMenu: NURSERY_CONFIG.showInMenu,
      menuCategory: NURSERY_CONFIG.menuCategory,
      menuSubcategory: NURSERY_CONFIG.menuSubcategory,
      menuTitle: NURSERY_CONFIG.localizationKey,
    },
  },
  {
    path: 'locality',
    pathMatch: 'full',
    component: Locality,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCALITY_CONFIG.permission,
      showInMenu: LOCALITY_CONFIG.showInMenu,
      menuCategory: LOCALITY_CONFIG.menuCategory,
      menuSubcategory: LOCALITY_CONFIG.menuSubcategory,
      menuTitle: LOCALITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand',
    pathMatch: 'full',
    component: Stand,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STAND_CONFIG.permission,
      showInMenu: STAND_CONFIG.showInMenu,
      menuCategory: STAND_CONFIG.menuCategory,
      menuSubcategory: STAND_CONFIG.menuSubcategory,
      menuTitle: STAND_CONFIG.localizationKey,
    },
  },
  {
    path: 'register',
    pathMatch: 'full',
    component: Register,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTER_CONFIG.permission,
      showInMenu: REGISTER_CONFIG.showInMenu,
      menuCategory: REGISTER_CONFIG.menuCategory,
      menuSubcategory: REGISTER_CONFIG.menuSubcategory,
      menuTitle: REGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'other-use',
    pathMatch: 'full',
    component: OtherUse,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OTHERUSE_CONFIG.permission,
      showInMenu: OTHERUSE_CONFIG.showInMenu,
      menuCategory: OTHERUSE_CONFIG.menuCategory,
      menuSubcategory: OTHERUSE_CONFIG.menuSubcategory,
      menuTitle: OTHERUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'cadastral-section',
    pathMatch: 'full',
    component: CadastralSection,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CADASTRALSECTION_CONFIG.permission,
      showInMenu: CADASTRALSECTION_CONFIG.showInMenu,
      menuCategory: CADASTRALSECTION_CONFIG.menuCategory,
      menuSubcategory: CADASTRALSECTION_CONFIG.menuSubcategory,
      menuTitle: CADASTRALSECTION_CONFIG.localizationKey,
    },
  },
  {
    path: 'office',
    pathMatch: 'full',
    component: Office,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OFFICE_CONFIG.permission,
      showInMenu: OFFICE_CONFIG.showInMenu,
      menuCategory: OFFICE_CONFIG.menuCategory,
      menuSubcategory: OFFICE_CONFIG.menuSubcategory,
      menuTitle: OFFICE_CONFIG.localizationKey,
    },
  },
  {
    path: 'internal-road',
    pathMatch: 'full',
    component: InternalRoad,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERNALROAD_CONFIG.permission,
      showInMenu: INTERNALROAD_CONFIG.showInMenu,
      menuCategory: INTERNALROAD_CONFIG.menuCategory,
      menuSubcategory: INTERNALROAD_CONFIG.menuSubcategory,
      menuTitle: INTERNALROAD_CONFIG.localizationKey,
    },
  },
  {
    path: 'firebreak-block',
    pathMatch: 'full',
    component: FirebreakBlock,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FIREBREAKBLOCK_CONFIG.permission,
      showInMenu: FIREBREAKBLOCK_CONFIG.showInMenu,
      menuCategory: FIREBREAKBLOCK_CONFIG.menuCategory,
      menuSubcategory: FIREBREAKBLOCK_CONFIG.menuSubcategory,
      menuTitle: FIREBREAKBLOCK_CONFIG.localizationKey,
    },
  },
  {
    path: 'local-corridor',
    pathMatch: 'full',
    component: LocalCorridor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCALCORRIDOR_CONFIG.permission,
      showInMenu: LOCALCORRIDOR_CONFIG.showInMenu,
      menuCategory: LOCALCORRIDOR_CONFIG.menuCategory,
      menuSubcategory: LOCALCORRIDOR_CONFIG.menuSubcategory,
      menuTitle: LOCALCORRIDOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'register-per-property',
    pathMatch: 'full',
    component: RegisterPerProperty,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTERPERPROPERTY_CONFIG.permission,
      showInMenu: REGISTERPERPROPERTY_CONFIG.showInMenu,
      menuCategory: REGISTERPERPROPERTY_CONFIG.menuCategory,
      menuSubcategory: REGISTERPERPROPERTY_CONFIG.menuSubcategory,
      menuTitle: REGISTERPERPROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'load-property',
    pathMatch: 'full',
    component: LoadProperty,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOADPROPERTY_CONFIG.permission,
      showInMenu: LOADPROPERTY_CONFIG.showInMenu,
      menuCategory: LOADPROPERTY_CONFIG.menuCategory,
      menuSubcategory: LOADPROPERTY_CONFIG.menuSubcategory,
      menuTitle: LOADPROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'ele-is',
    pathMatch: 'full',
    component: EleIs,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ELEIS_CONFIG.permission,
      showInMenu: ELEIS_CONFIG.showInMenu,
      menuCategory: ELEIS_CONFIG.menuCategory,
      menuSubcategory: ELEIS_CONFIG.menuSubcategory,
      menuTitle: ELEIS_CONFIG.localizationKey,
    },
  },
  {
    path: 'fence',
    pathMatch: 'full',
    component: Fence,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FENCE_CONFIG.permission,
      showInMenu: FENCE_CONFIG.showInMenu,
      menuCategory: FENCE_CONFIG.menuCategory,
      menuSubcategory: FENCE_CONFIG.menuSubcategory,
      menuTitle: FENCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'helmet',
    pathMatch: 'full',
    component: Helmet,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HELMET_CONFIG.permission,
      showInMenu: HELMET_CONFIG.showInMenu,
      menuCategory: HELMET_CONFIG.menuCategory,
      menuSubcategory: HELMET_CONFIG.menuSubcategory,
      menuTitle: HELMET_CONFIG.localizationKey,
    },
  },
  {
    path: 'local-road',
    pathMatch: 'full',
    component: LocalRoad,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCALROAD_CONFIG.permission,
      showInMenu: LOCALROAD_CONFIG.showInMenu,
      menuCategory: LOCALROAD_CONFIG.menuCategory,
      menuSubcategory: LOCALROAD_CONFIG.menuSubcategory,
      menuTitle: LOCALROAD_CONFIG.localizationKey,
    },
  },
  {
    path: 'mill',
    pathMatch: 'full',
    component: Mill,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MILL_CONFIG.permission,
      showInMenu: MILL_CONFIG.showInMenu,
      menuCategory: MILL_CONFIG.menuCategory,
      menuSubcategory: MILL_CONFIG.menuSubcategory,
      menuTitle: MILL_CONFIG.localizationKey,
    },
  },
  {
    path: 'other-use-per-register',
    pathMatch: 'full',
    component: OtherUsePerRegister,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OTHERUSEPERREGISTER_CONFIG.permission,
      showInMenu: OTHERUSEPERREGISTER_CONFIG.showInMenu,
      menuCategory: OTHERUSEPERREGISTER_CONFIG.menuCategory,
      menuSubcategory: OTHERUSEPERREGISTER_CONFIG.menuSubcategory,
      menuTitle: OTHERUSEPERREGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-per-register',
    pathMatch: 'full',
    component: StandPerRegister,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDPERREGISTER_CONFIG.permission,
      showInMenu: STANDPERREGISTER_CONFIG.showInMenu,
      menuCategory: STANDPERREGISTER_CONFIG.menuCategory,
      menuSubcategory: STANDPERREGISTER_CONFIG.menuSubcategory,
      menuTitle: STANDPERREGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'pile',
    pathMatch: 'full',
    component: Pile,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PILE_CONFIG.permission,
      showInMenu: PILE_CONFIG.showInMenu,
      menuCategory: PILE_CONFIG.menuCategory,
      menuSubcategory: PILE_CONFIG.menuSubcategory,
      menuTitle: PILE_CONFIG.localizationKey,
    },
  },
  {
    path: 'mill-sector-type',
    pathMatch: 'full',
    component: MillSectorType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MILLSECTORTYPE_CONFIG.permission,
      showInMenu: MILLSECTORTYPE_CONFIG.showInMenu,
      menuCategory: MILLSECTORTYPE_CONFIG.menuCategory,
      menuSubcategory: MILLSECTORTYPE_CONFIG.menuSubcategory,
      menuTitle: MILLSECTORTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'mill-sector',
    pathMatch: 'full',
    component: MillSector,
    canActivate: [authGuard, permissionGuard],
    data: {
        requiredPolicy: MILLSECTOR_CONFIG.permission,
        showInMenu: MILLSECTOR_CONFIG.showInMenu,
        menuCategory: MILLSECTOR_CONFIG.menuCategory,
        menuSubcategory: MILLSECTOR_CONFIG.menuSubcategory,
        menuTitle: MILLSECTOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'inventory-type',
    pathMatch: 'full',
    component: InventoryType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INVENTORYTYPE_CONFIG.permission,
      showInMenu: INVENTORYTYPE_CONFIG.showInMenu,
      menuCategory: INVENTORYTYPE_CONFIG.menuCategory,
      menuSubcategory: INVENTORYTYPE_CONFIG.menuSubcategory,
      menuTitle: INVENTORYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-unit',
    pathMatch: 'full',
    component: SoilUnit,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILUNIT_CONFIG.permission,
      showInMenu: SOILUNIT_CONFIG.showInMenu,
      menuCategory: SOILUNIT_CONFIG.menuCategory,
      menuSubcategory: SOILUNIT_CONFIG.menuSubcategory,
      menuTitle: SOILUNIT_CONFIG.localizationKey,
    },
  },
  {
    path: 'gender',
    pathMatch: 'full',
    component: Gender,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GENDER_CONFIG.permission,
      showInMenu: GENDER_CONFIG.showInMenu,
      menuCategory: GENDER_CONFIG.menuCategory,
      menuSubcategory: GENDER_CONFIG.menuSubcategory,
      menuTitle: GENDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'fauna-specie',
    pathMatch: 'full',
    component: FaunaSpecie,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FAUNASPECIE_CONFIG.permission,
      showInMenu: FAUNASPECIE_CONFIG.showInMenu,
      menuCategory: FAUNASPECIE_CONFIG.menuCategory,
      menuSubcategory: FAUNASPECIE_CONFIG.menuSubcategory,
      menuTitle: FAUNASPECIE_CONFIG.localizationKey,
    },
  },
  {
    path: 'packing-type',
    pathMatch: 'full',
    component: PackingType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PACKINGTYPE_CONFIG.permission,
      showInMenu: PACKINGTYPE_CONFIG.showInMenu,
      menuCategory: PACKINGTYPE_CONFIG.menuCategory,
      menuTitle: PACKINGTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'inventory-parameters',
    pathMatch: 'full',
    component: InventoryParameters,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INVENTORYPARAMETERS_CONFIG.permission,
      showInMenu: INVENTORYPARAMETERS_CONFIG.showInMenu,
      menuCategory: INVENTORYPARAMETERS_CONFIG.menuCategory,
      menuSubcategory: INVENTORYPARAMETERS_CONFIG.menuSubcategory,
      menuTitle: INVENTORYPARAMETERS_CONFIG.localizationKey,
    },
  },
  {
    path: 'spacing',
    pathMatch: 'full',
    component: Spacing,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPACING_CONFIG.permission,
      showInMenu: SPACING_CONFIG.showInMenu,
      menuCategory: SPACING_CONFIG.menuCategory,
      menuSubcategory: SPACING_CONFIG.menuSubcategory,
      menuTitle: SPACING_CONFIG.localizationKey,
    },
  },
  {
    path: 'inventory-sub-type',
    pathMatch: 'full',
    component: InventorySubType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INVENTORYSUBTYPE_CONFIG.permission,
      showInMenu: INVENTORYSUBTYPE_CONFIG.showInMenu,
      menuCategory: INVENTORYSUBTYPE_CONFIG.menuCategory,
      menuSubcategory: INVENTORYSUBTYPE_CONFIG.menuSubcategory,
      menuTitle: INVENTORYSUBTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-per-intermediate-logyard',
    pathMatch: 'full',
    component: StandPerIntermediateLogyard,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDPERINTERMEDIATELOGYARD_CONFIG.permission,
      showInMenu: STANDPERINTERMEDIATELOGYARD_CONFIG.showInMenu,
      menuCategory: STANDPERINTERMEDIATELOGYARD_CONFIG.menuCategory,
      menuTitle: STANDPERINTERMEDIATELOGYARD_CONFIG.localizationKey,
    },
  },
  {
    path: 'property-type-group',
    pathMatch: 'full',
    component: PropertyTypeGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTYTYPEGROUP_CONFIG.permission,
      showInMenu: PROPERTYTYPEGROUP_CONFIG.showInMenu,
      menuCategory: PROPERTYTYPEGROUP_CONFIG.menuCategory,
      menuSubcategory: PROPERTYTYPEGROUP_CONFIG.menuSubcategory,
      menuTitle: PROPERTYTYPEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'property-type',
    pathMatch: 'full',
    component: PropertyType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTYTYPE_CONFIG.permission,
      showInMenu: PROPERTYTYPE_CONFIG.showInMenu,
      menuCategory: PROPERTYTYPE_CONFIG.menuCategory,
      menuSubcategory: PROPERTYTYPE_CONFIG.menuSubcategory,
      menuTitle: PROPERTYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'crop-code',
    pathMatch: 'full',
    component: CropCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CROPCODE_CONFIG.permission,
      showInMenu: CROPCODE_CONFIG.showInMenu,
      menuCategory: CROPCODE_CONFIG.menuCategory,
      menuSubcategory: CROPCODE_CONFIG.menuSubcategory,
      menuTitle: CROPCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-type',
    pathMatch: 'full',
    component: StandType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDTYPE_CONFIG.permission,
      showInMenu: STANDTYPE_CONFIG.showInMenu,
      menuCategory: STANDTYPE_CONFIG.menuCategory,
      menuSubcategory: STANDTYPE_CONFIG.menuSubcategory,
      menuTitle: STANDTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-category',
    pathMatch: 'full',
    component: IncidentCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTCATEGORY_CONFIG.permission,
      showInMenu: INCIDENTCATEGORY_CONFIG.showInMenu,
      menuCategory: INCIDENTCATEGORY_CONFIG.menuCategory,
      menuSubcategory: INCIDENTCATEGORY_CONFIG.menuSubcategory,
      menuTitle: INCIDENTCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'certification-code',
    pathMatch: 'full',
    component: CertificationCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CERTIFICATIONCODE_CONFIG.permission,
      showInMenu: CERTIFICATIONCODE_CONFIG.showInMenu,
      menuCategory: CERTIFICATIONCODE_CONFIG.menuCategory,
      menuSubcategory: CERTIFICATIONCODE_CONFIG.menuSubcategory,
      menuTitle: CERTIFICATIONCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'team',
    pathMatch: 'full',
    component: Team,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TEAM_CONFIG.permission,
      showInMenu: TEAM_CONFIG.showInMenu,
      menuCategory: TEAM_CONFIG.menuCategory,
      menuSubcategory: TEAM_CONFIG.menuSubcategory,
      menuTitle: TEAM_CONFIG.localizationKey,
    },
  },  {
    path: 'third-party-destination',
    pathMatch: 'full',
    component: ThirdPartyDestination,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: THIRDPARTYDESTINATION_CONFIG.permission,
      showInMenu: THIRDPARTYDESTINATION_CONFIG.showInMenu,
      menuCategory: THIRDPARTYDESTINATION_CONFIG.menuCategory,
      menuSubcategory: THIRDPARTYDESTINATION_CONFIG.menuSubcategory,
      menuTitle: THIRDPARTYDESTINATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'cost-center-by-location',
    pathMatch: 'full',
    component: CostCenterByLocation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COSTCENTERBYLOCATION_CONFIG.permission,
      showInMenu: COSTCENTERBYLOCATION_CONFIG.showInMenu,
      menuCategory: COSTCENTERBYLOCATION_CONFIG.menuCategory,
      menuSubcategory: COSTCENTERBYLOCATION_CONFIG.menuSubcategory,
      menuTitle: COSTCENTERBYLOCATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'pile-detail',
    pathMatch: 'full',
    component: PileDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PILEDETAIL_CONFIG.permission,
      showInMenu: PILEDETAIL_CONFIG.showInMenu,
      menuCategory: PILEDETAIL_CONFIG.menuCategory,
      menuSubcategory: PILEDETAIL_CONFIG.menuSubcategory,
      menuTitle: PILEDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'supply-register',
    pathMatch: 'full',
    component: SupplyRegister,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUPPLYREGISTER_CONFIG.permission,
      showInMenu: SUPPLYREGISTER_CONFIG.showInMenu,
      menuCategory: SUPPLYREGISTER_CONFIG.menuCategory,
      menuSubcategory: SUPPLYREGISTER_CONFIG.menuSubcategory,
      menuTitle: SUPPLYREGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'supply-register-per-third-party-property',
    pathMatch: 'full',
    component: SupplyRegisterPerThirdPartyProperty,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG.permission,
      showInMenu: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG.showInMenu,
      menuCategory: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG.menuCategory,
      menuSubcategory: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG.menuSubcategory,
      menuTitle: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'register-area',
    pathMatch: 'full',
    component: RegisterArea,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTERAREA_CONFIG.permission,
      showInMenu: REGISTERAREA_CONFIG.showInMenu,
      menuCategory: REGISTERAREA_CONFIG.menuCategory,
      menuSubcategory: REGISTERAREA_CONFIG.menuSubcategory,
      menuTitle: REGISTERAREA_CONFIG.localizationKey,
    },
  },
  {
    path: 'register-value',
    pathMatch: 'full',
    component: RegisterValue,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTERVALUE_CONFIG.permission,
      showInMenu: REGISTERVALUE_CONFIG.showInMenu,
      menuCategory: REGISTERVALUE_CONFIG.menuCategory,
      menuSubcategory: REGISTERVALUE_CONFIG.menuSubcategory,
      menuTitle: REGISTERVALUE_CONFIG.localizationKey,
    },
  },
  {
    path: 'certificate-type',
    pathMatch: 'full',
    component: CertificateType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CERTIFICATETYPE_CONFIG.permission,
      showInMenu: CERTIFICATETYPE_CONFIG.showInMenu,
      menuCategory: CERTIFICATETYPE_CONFIG.menuCategory,
      menuSubcategory: CERTIFICATETYPE_CONFIG.menuSubcategory,
      menuTitle: CERTIFICATETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'certification-level',
    pathMatch: 'full',
    component: CertificationLevel,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CERTIFICATIONLEVEL_CONFIG.permission,
      showInMenu: CERTIFICATIONLEVEL_CONFIG.showInMenu,
      menuCategory: CERTIFICATIONLEVEL_CONFIG.menuCategory,
      menuSubcategory: CERTIFICATIONLEVEL_CONFIG.menuSubcategory,
      menuTitle: CERTIFICATIONLEVEL_CONFIG.localizationKey,
    },
  },
  {
    path: 'certification-type',
    pathMatch: 'full',
    component: CertificationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CERTIFICATIONTYPE_CONFIG.permission,
      showInMenu: CERTIFICATIONTYPE_CONFIG.showInMenu,
      menuCategory: CERTIFICATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: CERTIFICATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: CERTIFICATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'certificator',
    pathMatch: 'full',
    component: Certificator,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CERTIFICATOR_CONFIG.permission,
      showInMenu: CERTIFICATOR_CONFIG.showInMenu,
      menuCategory: CERTIFICATOR_CONFIG.menuCategory,
      menuSubcategory: CERTIFICATOR_CONFIG.menuSubcategory,
      menuTitle: CERTIFICATOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'distribution',
    pathMatch: 'full',
    component: Distribution,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DISTRIBUTION_CONFIG.permission,
      showInMenu: DISTRIBUTION_CONFIG.showInMenu,
      menuCategory: DISTRIBUTION_CONFIG.menuCategory,
      menuSubcategory: DISTRIBUTION_CONFIG.menuSubcategory,
      menuTitle: DISTRIBUTION_CONFIG.localizationKey,
    },
  },
  {
    path: 'flow-type',
    pathMatch: 'full',
    component: FlowType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FLOWTYPE_CONFIG.permission,
      showInMenu: FLOWTYPE_CONFIG.showInMenu,
      menuCategory: FLOWTYPE_CONFIG.menuCategory,
      menuSubcategory: FLOWTYPE_CONFIG.menuSubcategory,
      menuTitle: FLOWTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'management-type',
    pathMatch: 'full',
    component: ManagementType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MANAGEMENTTYPE_CONFIG.permission,
      showInMenu: MANAGEMENTTYPE_CONFIG.showInMenu,
      menuCategory: MANAGEMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: MANAGEMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: MANAGEMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'register-type',
    pathMatch: 'full',
    component: RegisterType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: REGISTERTYPE_CONFIG.permission,
      showInMenu: REGISTERTYPE_CONFIG.showInMenu,
      menuCategory: REGISTERTYPE_CONFIG.menuCategory,
      menuSubcategory: REGISTERTYPE_CONFIG.menuSubcategory,
      menuTitle: REGISTERTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'soil-based-crop-code',
    pathMatch: 'full',
    component: SoilBasedCropCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SOILBASEDCROPCODE_CONFIG.permission,
      showInMenu: SOILBASEDCROPCODE_CONFIG.showInMenu,
      menuCategory: SOILBASEDCROPCODE_CONFIG.menuCategory,
      menuSubcategory: SOILBASEDCROPCODE_CONFIG.menuSubcategory,
      menuTitle: SOILBASEDCROPCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-statement',
    pathMatch: 'full',
    component: WoodStatement,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODSTATEMENT_CONFIG.permission,
      showInMenu: WOODSTATEMENT_CONFIG.showInMenu,
      menuCategory: WOODSTATEMENT_CONFIG.menuCategory,
      menuSubcategory: WOODSTATEMENT_CONFIG.menuSubcategory,
      menuTitle: WOODSTATEMENT_CONFIG.localizationKey,
    },
  },

];

export const PLANNING_ROUTES_WITH_PERMISSIONS = PLANNING_ROUTES;
